import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "edit-case-page" }
const _hoisted_2 = { class: "edit-case-page__header" }
const _hoisted_3 = {
  key: 1,
  class: "edit-case-page__tabs"
}
const _hoisted_4 = { class: "edit-case-page__name label-l n-nowrap" }
const _hoisted_5 = {
  key: 0,
  class: "edit-case-page__name-sub"
}
const _hoisted_6 = {
  key: 1,
  class: "edit-case-page__name-sub edit-case-page__name-sub_error"
}
const _hoisted_7 = { class: "edit-case-page__content" }
const _hoisted_8 = {
  key: 0,
  style: {"font-size":"11px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", null, "Debug info", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "MODEL-ACL", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "CASE-ITEM-ACL", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, "VIDEO-ACL", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "ARCHIVED", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NTabs = _resolveComponent("NTabs")!
  const _component_CaseForm = _resolveComponent("CaseForm")!
  const _component_CaseVideos = _resolveComponent("CaseVideos")!
  const _component_CasePhotos = _resolveComponent("CasePhotos")!
  const _component_CaseClusterPage = _resolveComponent("CaseClusterPage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isNew)
        ? (_openBlock(), _createBlock(_component_NButton, {
            key: 0,
            "data-qa": `${_ctx.dataQa}.close`,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
            type: "secondary",
            icon: "close",
            round: "",
            class: "edit-case-page__close-button"
          }, null, 8, ["data-qa"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(_ctx.compItem.name), 1),
              (_ctx.isArchived)
                ? (_openBlock(), _createElementBlock("sub", _hoisted_5, _toDisplayString(_ctx.$t('cases.status_' + _ctx.compItem.status, 'f')), 1))
                : _createCommentVNode("", true),
              (_ctx.isError)
                ? (_openBlock(), _createElementBlock("sub", _hoisted_6, _toDisplayString(_ctx.$t('cases.status_error', 'f')), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_NTabs, {
              "data-qa": `${_ctx.dataQa}.tabs`,
              class: "edit-case-page__tabs-content",
              items: _ctx.tabItems,
              modelValue: _ctx.state.pageType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.pageType) = $event)),
              size: "big",
              hasArrows: ""
            }, null, 8, ["data-qa", "items", "modelValue"])
          ]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.debug)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createTextVNode(": " + _toDisplayString(_ctx.maxAcl), 1),
            _hoisted_11,
            _hoisted_12,
            _createTextVNode(": " + _toDisplayString(_ctx.currentItemAcl) + " ", 1),
            _hoisted_13,
            _hoisted_14,
            _createTextVNode(": " + _toDisplayString(_ctx.videoAcl), 1),
            _hoisted_15,
            _hoisted_16,
            _createTextVNode(": " + _toDisplayString(_ctx.compItem.status === 'archived'), 1),
            _hoisted_17,
            _createTextVNode(" " + _toDisplayString(_ctx.compItem) + " ", 1),
            _hoisted_18,
            _createTextVNode(" New " + _toDisplayString(_ctx.isNew) + ", " + _toDisplayString(_ctx.compId), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.pageType === _ctx.TabNames.Info)
        ? (_openBlock(), _createBlock(_component_CaseForm, {
            key: 1,
            item: _ctx.compItem,
            disabled: (_ctx.compItem.id === 0 ? !_ctx.maxAcl.add : !_ctx.currentItemAclEdit) || _ctx.module.loading || _ctx.isArchived || _ctx.module.saving,
            onSave: _ctx.saveHandler,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
          }, null, 8, ["item", "disabled", "onSave"]))
        : _createCommentVNode("", true),
      (_ctx.module.loaded)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.state.pageType === _ctx.TabNames.Sources)
              ? (_openBlock(), _createBlock(_component_CaseVideos, {
                  key: 0,
                  item: _ctx.compItem,
                  caseAcl: _ctx.currentItemAcl,
                  tab: _ctx.tab + '__videos',
                  onUpdateSubPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateSubPage($event)))
                }, null, 8, ["item", "caseAcl", "tab"]))
              : _createCommentVNode("", true),
            (_ctx.state.pageType === _ctx.TabNames.Photos)
              ? (_openBlock(), _createBlock(_component_CasePhotos, {
                  key: 1,
                  item: _ctx.compItem,
                  caseAcl: _ctx.currentItemAcl,
                  tab: _ctx.tab + '__photos',
                  "case-acl": _ctx.currentItemAcl
                }, null, 8, ["item", "caseAcl", "tab", "case-acl"]))
              : _createCommentVNode("", true),
            (_ctx.state.pageType === _ctx.TabNames.Clusters)
              ? (_openBlock(), _createBlock(_component_CaseClusterPage, {
                  key: 2,
                  type: "clusters",
                  item: _ctx.compItem,
                  isCaseArchived: _ctx.isArchived,
                  participantsAcl: _ctx.relatedCaseParticipantsAcl,
                  presetFilters: _ctx.state.caseClusterFilters,
                  onUpdateSubPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateSubPage($event)))
                }, null, 8, ["item", "isCaseArchived", "participantsAcl", "presetFilters"]))
              : _createCommentVNode("", true),
            (_ctx.state.pageType === _ctx.TabNames.Participants)
              ? (_openBlock(), _createBlock(_component_CaseClusterPage, {
                  key: 3,
                  type: "participants",
                  item: _ctx.compItem,
                  isCaseArchived: _ctx.isArchived,
                  "participants-acl": _ctx.relatedCaseParticipantsAcl
                }, null, 8, ["item", "isCaseArchived", "participants-acl"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}